import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TierComponent } from './tier.component';

const routes: Routes = [
  {
    path: '',
    component: TierComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TierRoutingModule {}
